module.exports = __webpack_public_path__ + "media/images/icons/favicon-a59783b52d3be14000ece4a5b0599a04.ico";